var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "8"
    }
  }, [_c('partner-report-rental-card', {
    staticClass: "mb-8"
  })], 1), !_vm.isMobile ? _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('partner-report-select-rental-company-card'), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("objects.contract.customer.approvals")) + " ")]), _c('v-card-text', [_c('rental-approval-limits-sheet', {
    model: {
      value: _vm.report,
      callback: function callback($$v) {
        _vm.report = $$v;
      },
      expression: "report"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }